(function() {
    'use strict';

    /*global angular*/
    var module = angular.module('vhols');

    module.service('affinityService', ["$http", function($http) {

        var url = '/.rest/affinity/v1';

        var clean = function (resp) {
            return resp.data || [];
        };

        function getPartners() {
            var apiUrl = url + '/partners';
            return $http.get(apiUrl, {cache: false}).then(clean);
        }

        function postMember(data) {
            var apiUrl = url + '/members';
            return $http.post(apiUrl, data);
        }

        return {
            getPartners: getPartners,
            postMember: postMember
        };
    }]);

})();
